import React, { useState } from 'react';
import classes from './EditableRow.module.scss'
import { UserService } from '../../services/UserService';
import { globalErrorHandler } from '../../utils/errorHandler';
import { useLoader } from '../../customHooks/loader';
import { toast } from 'react-toastify';

const EditableRow = ({ label, initialValue, queryKey, disableEditting = false }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = useState(initialValue);
    const loader = useLoader();

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleSaveClick = () => {
        UserService.updateUserDetails(
            { key: queryKey, value },
            handleUpdateUserDetailsSuccess,
            globalErrorHandler,
            loader
        );
        console.log('Saved value:', value);
    };

    const handleUpdateUserDetailsSuccess = ({ data }) => {
        console.log(data.data);
        toast.success(`${label} updated successfully !`);
        if (queryKey === 'password') setValue("****");
        setIsEditing(false);
    }

    const handleCancelClick = () => {
        setIsEditing(false);
        setValue(initialValue); // Revert to initial value
    };

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    return (
        <div className={classes.ContactDetails}>
            <div className={classes.ContactDetailsContainer}>
                <div className={classes.ContactLabel}>{label}</div>
                {!isEditing ?
                    (
                        <div className={classes.HeadingWithButton}>
                            <div className={classes.Heading}>{value}</div>
                            {!disableEditting ? <div className={classes.HeadingActionButton} onClick={handleEditClick}>Change</div> : null}
                        </div>
                    ) : (
                        <div className={classes.HeadingWithButton}>
                            <input
                                className={classes.Heading}
                                type="text"
                                value={value}
                                onChange={handleChange}
                            />
                            <div className={classes.EditingHeadingWithButton}>
                                <div className={classes.HeadingActionButton} onClick={handleSaveClick}>Save</div>
                                <div className={classes.HeadingActionButton} onClick={handleCancelClick}>Cancel</div>
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
        // <div style={{ marginBottom: '10px' }}>
        //   <label style={{ marginRight: '10px' }}>{label}:</label>
        //   {isEditing ? (
        //     <>

        //       <button onClick={handleSaveClick} style={{ marginRight: '5px' }}>Save</button>
        //       <button onClick={handleCancelClick}>Cancel</button>
        //     </>
        //   ) : (
        //     <>
        //       <span style={{ marginRight: '10px' }}>{value}</span>
        //       <button onClick={handleEditClick}>Edit</button>
        //     </>
        //   )}
        // </div>
    );
};

export default EditableRow;
